export const RichTextConstants = {
  H1Regex: new RegExp('<h1>', 'g'),
  H2Regex: new RegExp('<h2>', 'g'),
  LinesRegex: new RegExp('<p>', 'g'),
  ListItemRegex: new RegExp('<li>', 'g'),
  HttpsRegex: /https?:\/\/[^\s]+$/,
  HttpRegex: /http?:\/\/[^\s]+$/,
  HTMLRegex: /<\/?[a-z][\s\S]*>/i,
  NewLineRegex: /(?:\r\n|\r|\n)/g,
  HTMLTagsRegex: /<[^>]*>?/gm,
  P: '<p>',
  ClosingP: '</p>',
  List: '<ul>',
  OrderedList: '<ol>',
  ListItem: '<li>',
  ClosingListItem: '</li>',
  EllipsisForList: '...</li></ul>',
  EllipsisForOrderedList: '...</li></ol>',
  EllipsisForP: '<p>...</p>',
  NewLine: '<br>',
  PlaceHolderForOnlyAttachments: '<p>Click show more to see attachments</p>',
  PROTOCOL: '://',
  HTTP: 'http',

}
